export default "__VITE_ASSET__IKZnpU_o__"